//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createAction } from '@utils/actions';
import { IStateWithParams } from './routingModels';

export const enum RoutingActionType {
    StateTransitionRedirected = 'ROUTING_STATE_TRANSITION_REDIRECTED',
    StateTransitionStart = 'ROUTING_STATE_TRANSITION_START',
    StateTransitionSuccess = 'ROUTING_STATE_TRANSITION_SUCCESS',
    StateTransitionError = 'ROUTING_STATE_TRANSITION_ERROR',
}

export function stateTransitionRedirected() {
  return createAction({
    type: RoutingActionType.StateTransitionRedirected,
  });
}

export function stateTransitionStart(toState: IStateWithParams, fromState: IStateWithParams) {
  return createAction({
    type: RoutingActionType.StateTransitionStart,
    toState,
    fromState,
  });
}

export function stateTransitionSuccess(toState: IStateWithParams, fromState: IStateWithParams) {
  return createAction({
    type: RoutingActionType.StateTransitionSuccess,
    toState,
    fromState,
  });
}

export function stateTransitionError(error: unknown) {
  return createAction({
    type: RoutingActionType.StateTransitionError,
    error,
  });
}

export type RoutingActions = ReturnType<
    typeof stateTransitionRedirected |
    typeof stateTransitionStart |
    typeof stateTransitionSuccess |
    typeof stateTransitionError
>;
